module.exports = __webpack_public_path__ + "img/Percentage Icon - white.172bc541.svg";